import { CHATBOT_SECTIONS, type ChatbotSection } from "@/lib/types"

/**
 * Rótulos e descrições das seções que o dono pode liberar para um convidado.
 * Fonte única para o seletor do convite, os chips de acesso e a tela de aceite.
 * "Usuários" é a seção de administração: quem recebe pode convidar, remover e
 * ajustar o acesso de outras pessoas, como um coadministrador.
 */
export const CHATBOT_SECTION_META: Record<ChatbotSection, { label: string; description: string }> = {
  general: { label: "Configurações gerais", description: "Identidade e disponibilidade do assistente" },
  appearance: { label: "Aparência", description: "Marca, cores e visual do widget" },
  ai: { label: "Configuração de IA", description: "Modelo, instruções e perguntas sugeridas" },
  content: { label: "Fontes de conteúdo", description: "Domínios, páginas e arquivos de conhecimento" },
  analytics: { label: "Analytics", description: "Conversas, funil do balão e histórico" },
  installation: { label: "Instalação", description: "Domínios autorizados e código de instalação" },
  integrations: { label: "Integrações", description: "Atendimento humano com Genesys Cloud" },
  users: { label: "Usuários", description: "Convidar, remover e ajustar o acesso de outras pessoas" },
}

/**
 * Padrão do convite: tudo menos Integrações, que guarda credenciais da Genesys,
 * e Usuários, que dá poderes de administração — os dois entram desmarcados e o
 * dono liga de propósito quando for o caso.
 */
export const DEFAULT_INVITE_SECTIONS: ChatbotSection[] = ["general", "appearance", "ai", "content", "analytics", "installation"]

export function orderedChatbotSections(sections: readonly ChatbotSection[]): ChatbotSection[] {
  return CHATBOT_SECTIONS.filter((section) => sections.includes(section))
}

/** Seções que a pessoa que está vendo pode conceder: dono e superadmin concedem tudo. */
export function grantableChatbotSections(access?: { isOwner: boolean; isSuperadmin: boolean; sections: ChatbotSection[] }): ChatbotSection[] {
  return !access || access.isOwner || access.isSuperadmin ? [...CHATBOT_SECTIONS] : orderedChatbotSections(access.sections)
}
